import { Paragraph } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';

interface ReadOnly {
  readOnly?: boolean;
}

export const CardInner = styled.div<ReadOnly>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;
  pointer-events: ${(props): string => (props.readOnly ? 'none' : '')};
  opacity: ${(props): string => (props.readOnly ? '0.7' : '')};
`;

export const StyledComponentContainer = styled(Paragraph)``;
